module.exports = __webpack_public_path__ + "/img/3dbe680360532480e75bc891451b35e8.png";